// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fa353bf0","428":"f5192641","453":"6acfa267","672":"ab11b5fa","677":"2f0f8775","688":"48d6dc19"}[chunkId] + ".chunk.js";
};